import { Box, Circle, Point, QuadTree } from "js-quadtree"
import { QuadTreeConfig } from "js-quadtree/dist/types"

export class Qtree extends QuadTree {
  readonly lastUpdatedAt: number = +new Date()

  private readonly callback

  // Cache circle inputs
  private lastQueryCircleInput = {
    x: null,
    y: null,
    radius: null
  }

  // Cache circle points associated to the cached circle inputs
  private lastQueryCircleData = []

  constructor(
    container: Box,
    config: QuadTreeConfig,
    subscribeQueryPoints?: (points: Point[]) => void,
    points?: Point[]
  ) {
    super(container, config, points)
    this.callback = subscribeQueryPoints || ((points) => points)
  }

  // For circle only
  queryCirclePoints(x: number, y: number, radius: number): void {
    if (
      this.lastQueryCircleInput.x === x &&
      this.lastQueryCircleInput.y === y &&
      this.lastQueryCircleInput.radius === radius
    ) {
      this.callback(this.lastQueryCircleData.slice(), x, y)
      return
    }

    const points = this.query(new Circle(x, y, radius))
    this.lastQueryCircleInput = {
      x,
      y,
      radius
    }

    this.lastQueryCircleData = points

    this.callback(points, x, y)
  }

  // Send empty data to reset
  hide() {
    this.callback([])
  }
}
